import React, { useState, useEffect } from 'react'
import { Text } from '../../../../constants/TextConstants'
import { useNavigate } from 'react-router-dom'
import { epagAPI } from '../../../../API/epagAPI'
import { useGetToken } from '../../../../hooks/useGetToken'
import { RoleListWrapper, ErrorText, Container, Section } from '../../styles'
import { ListManagementTable } from '../../shared/table'

export const TechnicalLevels = () => {
  const [lists, setLists] = useState([])
  const [listsSorted, setListsSorted] = useState([])
  const [isLoadingLists, setIsLoadingLists] = useState(true)
  const [ErrorFetch, setErrorFetch] = useState('')
  const [totalItems, setTotalItems] = useState(20)
  const { token } = useGetToken()
  const navigate = useNavigate()
  const skillType = 'technical_levels'

  useEffect(() => {
    setIsLoadingLists(true)
    if (token) {
      getTechLevelsList()
    }
  }, [token])

  const getTechLevelsList = () => {
    epagAPI
      .GetSkills(skillType, token)
      .then((result) => {
        if (result) {
          setLists(result[0].values)
          setListsSorted(result[0].values)
          setTotalItems(result[0].values.length)
          setIsLoadingLists(false)
          setErrorFetch('')
        } else {
          setErrorFetch('')
          navigate('/NotFound', { replace: true })
        }
      })
      .catch((error) => {
        setErrorFetch(error.message)
        setIsLoadingLists(false)
        navigate('/Forbidden', { replace: true })
      })
  }

  const handleSearch = (value) => {
    if (value !== '') {
      const filteredList = lists.filter((item) => {
        return item.toLowerCase().includes(value.toLowerCase())
      })
      setListsSorted(filteredList)
      setTotalItems(filteredList.length)
    } else {
      setListsSorted(lists)
      setTotalItems(lists.length)
    }
  }

  const handleUpdateList = () => {
    getTechLevelsList()
  }

  return (
    <Container>
      <Section>
        <RoleListWrapper>
          <ListManagementTable
            title={Text.TechLevels}
            lists={lists}
            isLoadingLists={isLoadingLists}
            listSorted={listsSorted}
            setListsorted={setListsSorted}
            totalItems={totalItems}
            handleSearch={handleSearch}
            skillName={Text.TechLevel}
            skillType={skillType}
            updateList={handleUpdateList}
          />
          {ErrorFetch !== '' && <ErrorText>{ErrorFetch}</ErrorText>}
        </RoleListWrapper>
      </Section>
    </Container>
  )
}
